import { render, staticRenderFns } from "./TaskHistoryCommonFilters.vue?vue&type=template&id=3501828d&"
import script from "./TaskHistoryCommonFilters.vue?vue&type=script&lang=js&"
export * from "./TaskHistoryCommonFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports